<template>
  <div>
    <div class="hd">
      <div class="hd-main">
        <div class="ep-hd-info">
          <div class="ep-logo">
            <img src="../assets/img/logo.png" alt="sony" />
          </div>
          <div class="ep-order-status"><h1>维修单支付</h1></div>
        </div>
      </div>
    </div>
    <div class="bd">
      <div class="bd-main">
        <div class="ep-wrapper">
          <div
            class="ep-pay-step ep-step-channel bd-main-container"
            style="display: block"
          >
            <div class="ep-order-detail">
              <div>
                <div class="ep-order-tit">
                  <dl>
                    <dt>商品订单：</dt>
                    <dd>{{orderSn}}</dd>
                  </dl>
                </div>
                <div class="ep-order-tit">
                  <span
                    >支付金额：<em class="rmb"><i>¥</i>{{total}}</em></span
                  >
                  <a
                    @click="showDetail = !showDetail"
                    class="ep-order-view"
                    data-action="expend"
                    ><span>订单详情</span><i class="ep-icon ep-icon-arrow"></i
                  ></a>
                </div>
                <div class="ep-order-con" v-show="showDetail">
                  <dl>
                    <dt>商品名称：</dt>
                    <dd>维修单</dd>
                  </dl>
                  <dl>
                    <dt>支付订单：</dt>
                    <dd>{{serviceSheetNo}}</dd>
                  </dl>
                  <dl>
                    <dt>应付金额：</dt>
                    <dd>
                      <span class="rmb"><i>￥</i>{{total}}</span>
                    </dd>
                  </dl>
                  <!-- <dl>
                    <dt>购买时间：</dt>
                    <dd>2022年03月14日</dd>
                  </dl> -->
                </div>
              </div>
            </div>
            <div class="ep-pay-method ep-pay-methods">
              <dl>
                <dt>支付方式：</dt>
                <dd class="pay-channel">
                  <div class="ep-pay-method-list-tit">
                    <ul>
                      <li
                        class="ep-channel-item-wechat selected"
                        data-type="wechat"
                        title="微信支付"
                      >
                        <span class="ep-icon ep-icon-wxpay"></span>
                        <span class="ep-pay-method-name">微信支付</span>
                        <!---->
                        <i class="ep-icon ep-icon-selected"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="ep-pay-method-list-con">
                    <div class="con channel-wechat show">
                      <div class="clearfix">
                        <div class="fl">
                          <!-- <div class="ep-qrcode-loading hide">
                          <img
                            src="//midas.gtimg.cn/enterprise/images/loading.gif"
                            width="80"
                            height="80"
                          />
                        </div> -->
                          <div class="ep-wxpay-qrcode-wrap" ref="qrCodeUrl">
                            <!-- <img
                            src="//pay.qq.com/cgi-bin/account/get_qr_image.cgi?size=200&amp;orig=1&amp;url=weixin%3A%2F%2Fwxpay%2Fbizpayurl%3Fpr%3DusBdBBezz"
                            height="200"
                            width="200"
                            class="ep-wxpay-qrcode"
                          /> -->
                          </div>
                          <div class="ep-wxpay-qrcode-notice">
                            请打开手机微信，扫一扫完成支付
                          </div>
                        </div>
                        <div class="fl ep-wxpay-qrcode-tip">
                          <img src="../assets/img/ep_sys_wx_tip.jpg" />
                        </div>
                      </div>
                      <!--<div class="ep-qrcode-notice">距离二维码过期还剩<em>30</em>秒，过期后请刷新页面重新获取二维码</div>-->
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import api from "../common/utils/api";
import http from "axios";
export default {
  data() {
    return {
      payTimeSec: 120, //支付倒计时
      total: 0, //支付金额
      codeUrl: "", //支付二维码内容
      orderSn: "", // 微信订单号
      outSn: "", //系统订单号
      serviceSheetNo: "", // 维修单号
      clientSn: "", // 商户编号
      storeSn: "", //终端编号
      showDetail: false, //是否展示订单详情
    };
  },
  methods: {
    //生成支付二维码
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.codeUrl,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        margin: 0,
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //获取相关参数
    getParams() {
      let params = localStorage.getItem("wxpayParams");
      let parsePar = JSON.parse(params);
      this.total = parsePar.total;
      this.codeUrl = parsePar.codeUrl;
      this.orderSn = parsePar.orderSn;
      this.outSn = parsePar.outSn;
      this.serviceSheetNo = parsePar.serviceSheetNo;
      this.clientSn = parsePar.clientSn;
      this.storeSn = parsePar.storeSn;
      this.creatQrCode();
      // this.times();
      this.timesQuery();
    },
    //查询支付状态
    queryOrder() {
      let url = api.reservation.queryOrder();
      let params = {
        cusid: this.storeSn,
        reqsn: this.orderSn
      };
      http.post(url, params).then((res) => {
        console.log("========订单查询中============");
        let status = res.data.data.trxstatus;
        // 如果支付成功或超时未支付，跳入订单结果页
        if (status === '0000' || status === '3045') {
          clearInterval(this.timerQuery);
          this.$router.push({
            name: "intermediateWx",
          });
        }
      });
    },
    /**
     * 轮询查询支付状态
     * 10s查询一次
     */
    timesQuery() {
      //开启倒计时
      this.timerQuery = setInterval(() => {
        this.queryOrder();
      }, 10000);
    },

    /**
     * 倒计时计算支付剩余时间
     */
    times() {
      //开启倒计时
      this.timer = setInterval(() => {
        this.payTimeSec--;
        if (this.payTimeSec === 0) {
          console.log("==========倒计时已结束=============");
          //倒计时结束，关闭订单查询，跳入订单结果页
          clearInterval(this.timer);
          clearInterval(this.timerQuery);
          this.$router.push({
            name: "intermediateWx",
          });
        }
      }, 1000);
    },
  },
  mounted() {
    //移出默认添加的头部和底部
    var header = document.getElementById("getHeader");
    var footer = document.getElementById("getFooter");
    header.remove();
    footer.remove();
    this.getParams();
    // this.creatQrCode();
  },
};
</script>
<style type="text/css" scoped>
i,
cite,
em,
var,
address,
dfn {
  font-style: normal;
}

li {
  list-style: none;
}

body {
  background: #fff;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
img {
  max-width: 100%;
  vertical-align: middle;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>
<style type="text/css" scoped>
.ep-icon {
  background-image: url("../assets/img/ep_new_sprites.png");
  background-repeat: no-repeat;
  display: block;
}
.ep-icon-success,
.ep-icon-fail {
  width: 23px;
  height: 23px;
}
.ep-icon-success {
  background-position: 0 0;
}
.ep-icon-fail {
  background-position: 0 -25px;
}
.ep-icon-warning {
  background-position: -25px -25px;
}
.ep-icon-close {
  width: 13px;
  height: 13px;
  background-position: -36px -71px;
}
.ep-icon-wxpay {
  width: 22px;
  height: 19px;
  background-position: 0 -50px;
}

.ep-icon-qqpay {
  width: 16px;
  height: 18px;
  background-position: 0 -71px;
}
.ep-icon-tenpay {
  width: 56px;
  height: 26px;
  background-position: 0 -117px;
}
.ep-icon-unionpay {
  width: 32px;
  height: 20px;
  background-position: 0 -173px;
}
.ep-icon-selected {
  width: 20px;
  height: 20px;
  background-position: -25px 0;
}
.ep-icon-arrow {
  width: 10px;
  height: 8px;
  background-position: -35px -175px;
}
.ep-icon-radio {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  width: 14px;
  height: 14px;
  background-position: -43px -195px;
}
.selected .ep-icon-radio {
  background-position: -43px -211px;
}
.disabled .ep-icon-radio {
  background-position: -43px -227px;
}

.ep-icon-clock {
  width: 21px;
  height: 21px;
  background-position: -5px -22px;
}
.ep-icon-clock,
.ep-icon-clock2 {
  width: 16px;
  height: 16px;
  background-position: -36px -22px;
}
.ep-icon-detail {
  width: 12px;
  height: 13px;
  background-position: -36px -48px;
}
.ep-icon-detail,
.ep-icon-help {
  width: 16px;
  height: 16px;
  background-position: -77px -5px;
}
.ep-icon-output {
  width: 13px;
  height: 13px;
  background-position: -62px -31px;
}
.ep-icon-output,
.ep-icon-sale {
  width: 16px;
  height: 16px;
  background-position: -5px -54px;
}
.disabled .ep-icon-wxpay {
  background-position: -24px -50px;
}
.disabled .ep-icon-qqpay {
  background-position: -18px -71px;
}
.disabled .ep-icon-tenpay {
  background-position: 0 -145px;
}
.disabled .ep-icon-unionpay {
  background-position: 0 -193px;
}
.disabled .ep-icon-alipay {
  background-position: -17px -212px;
}
@media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
  .ep-icon {
    background-image: url("//midas.gtimg.cn/enterprise/images/ep_new_sprites@2x.png");
    background-repeat: no-repeat;
    background-size: 60px 250px;
  }
}
.ico_icbc,
.ico_cmb,
.ico_ccb,
.ico_abc,
.ico_boc,
.ico_spdb,
.ico_sdb,
.ico_cib,
.ico_bob,
.ico_ceb,
.ico_comm,
.ico_cmbc,
.ico_citic,
.ico_gdb,
.ico_pab,
.ico_psbc {
  width: 18px;
}
.ico_icbc,
.ico_cmb,
.ico_ccb,
.ico_abc,
.ico_boc,
.ico_spdb,
.ico_sdb,
.ico_cib,
.ico_bob,
.ico_ceb,
.ico_comm,
.ico_cmbc,
.ico_citic,
.ico_gdb,
.ico_pab,
.ico_psbc,
.ico_union,
.ico_jsb,
.ico_srcb,
.ico_hkb,
.ico_nbcb,
.ico_njcb,
.ico_bosh,
.ico_hxb,
.ico_hzb,
.ico_bea,
.ico_ordos,
.ico_cbhb,
.ico_jzb,
.ico_gdrcu,
.ico_nccb,
.ico_glccb,
.ico_bsb,
.ico_ynrcc,
.ico_gzcb,
.ico_cqrcb,
.ico_zjcb {
  background: url(//midas.gtimg.cn/enterprise/images/bank_ico.png) no-repeat;
  display: inline-block;
  height: 18px;
  margin-right: 2px;
  line-height: 999px;
  overflow: hidden;
  position: relative;
  vertical-align: -4px;
  *vertical-align: 0;
  z-index: 0;
}
.ico_jsb,
.ico_srcb,
.ico_hkb,
.ico_nbcb,
.ico_njcb,
.ico_bosh,
.ico_hxb,
.ico_hzb,
.ico_bea,
.ico_ordos,
.ico_cbhb,
.ico_jzb,
.ico_gdrcu,
.ico_nccb,
.ico_glccb,
.ico_bsb,
.ico_ynrcc,
.ico_gzcb,
.ico_cqrcb,
.ico_zjcb {
  width: 18px;
}
.ico_icbc {
  background-position: 0 0;
}
.ico_cmb {
  background-position: -18px 0;
}
.ico_ccb {
  background-position: -36px 0;
}
.ico_abc {
  background-position: -54px 0;
}
.ico_boc {
  background-position: -72px 0;
}
.ico_spdb {
  background-position: -54px -18px;
}
.ico_sdb {
  background-position: -108px -18px;
}
.ico_cib {
  background-position: 0 -18px;
}
.ico_bob {
  background-position: -126px -18px;
}
.ico_ceb {
  background-position: -90px 0;
}
.ico_comm {
  background-position: -36px -18px;
}
.ico_cmbc {
  background-position: -90px -18px;
}
.ico_citic {
  background-position: -126px 0;
}
.ico_gdb {
  background-position: -72px -18px;
}
.ico_pab {
  background-position: 0 -36px;
}
.ico_psbc {
  background-position: -18px -18px;
}
.ico_union {
  background-position: -27px -36px;
  width: 27px;
}
.ico_jsb {
  background-position: -54px -36px;
}
.ico_srcb {
  background-position: -72px -37px;
}
.ico_nbcb {
  background-position: -90px -36px;
}
.ico_njcb {
  background-position: -108px -36px;
}
.ico_hkb {
  background-position: -126px -36px;
}
.ico_bosh {
  background-position: 0 -54px;
}
.ico_hxb {
  background-position: -18px -54px;
}
.ico_hzb {
  background-position: -36px -54px;
}
.ico_bea {
  background-position: -54px -54px;
}
.ico_ordos {
  background-position: -72px -54px;
}
.ico_cbhb {
  background-position: -108px -54px;
}
.ico_jzb {
  background-position: -90px -54px;
}
.ico_gdrcu {
  background-position: 0 -73px;
}
.ico_nccb {
  background-position: -18px -73px;
}
.ico_glccb {
  background-position: -36px -73px;
}
.ico_bsb {
  background-position: -54px -73px;
}
.ico_ynrcc {
  background-position: -72px -73px;
}
.ico_gzcb {
  background-position: -90px -73px;
}
.ico_cqrcb {
  background-position: -108px -73px;
}
.ico_zjcb {
  background-position: -126px -73px;
}
.ep-sprite3 {
  background-image: url(//midas.gtimg.cn/enterprise/images/ep-sprite3.png);
  background-repeat: no-repeat;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  vertical-align: middle;
}
.ep-sprite3.ep-icon-notice {
  background-position: -5px -5px;
  width: 16px;
  height: 16px;
}
.ep-sprite3.ep-icon-phone {
  background-position: -5px -31px;
  width: 11px;
  height: 17px;
}
.ep-sprite3.ep-icon-right {
  background-position: -5px -58px;
  width: 16px;
  height: 13px;
}
.ep-sprite3.ep-icon-transfer {
  background-position: -5px -81px;
  width: 22px;
  height: 22px;
}
@media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
  .ep-sprite3 {
    background-image: url(//midas.gtimg.cn/enterprise/images/ep-sprite3@2x.png);
    background-size: 32px 108px;
  }
}
.ep-btn {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  border-radius: 2px;
  text-align: center;
  box-sizing: border-box;
  vertical-align: top;
  transition: color 0.1s ease-in, background-color 0.1s ease-in;
}
.ep-btn:hover {
  text-decoration: none;
}
.ep-btn.ep-btn-blue {
  width: 130px;
  height: 50px;
  background-color: #4580cb;
  border: 1px solid #3875c1;
  color: #fff;
  font-size: 16px;
  line-height: 50px;
}
.ep-btn.ep-btn-blue.h42 {
  height: 42px;
  line-height: 42px;
}
.ep-btn.ep-btn-blue:hover {
  background-color: #4495de;
}
.ep-btn.ep-btn-blue:active {
  background-color: #2e7bc0;
}
.ep-btn.ep-btn-blue.disabled,
.ep-btn.ep-btn-blue:disabled {
  background-color: #b1b1b1;
  border-color: #b1b1b1;
  cursor: not-allowed;
}
.ep-btn.ep-btn-blue.ep-btn-normal {
  width: 118px;
  height: 40px;
  line-height: 38px;
}
.ep-btn.ep-btn-blue.small {
  width: auto;
  padding: 0 15px;
  height: 28px;
  line-height: 26px;
  font-size: 14px;
}

.ep-btn.ep-btn-white.h42 {
  height: 42px;
  line-height: 42px;
}
.ep-btn.ep-btn-white:hover {
  background-image: linear-gradient(
    to top,
    #fafafa 0%,
    #f3f3f3 74%,
    #ebebeb 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#f1f1f1, endcolorstr=#fafafa, gradientType=0);
}
.ep-btn.ep-btn-white:active {
  background-image: linear-gradient(
    to top,
    #f7f7f7 0%,
    #ededed 74%,
    #e2e2e2 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#e9e9e9, endcolorstr=#f7f7f7, gradientType=0);
}
.ep-btn.ep-btn-disabled {
  border-color: #b1b1b1;
  background-color: #b1b1b1;
  color: #fff;
  cursor: not-allowed;
}
.ep-btn.ep-btn-disabled:hover,
.ep-btn.ep-btn-disabled:active {
  border-color: #b1b1b1;
  background-color: #b1b1b1;
  color: #fff;
}
.clearfix {
  zoom: 1;
  clear: both;
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-mr10 {
  margin-right: 10px;
}
.rmb {
  font-size: 14px;
}
.rmb i {
  font-size: 12px;
}
.text1 {
  font-size: 16px;
  color: #000;
}
.text2 {
  font-size: 14px;
  color: #707070;
}
.text3 {
  font-size: 14px;
  color: #939393;
}
.price {
  color: #fa7134;
}
a {
  color: #3584cb;
}
a:hover {
  text-decoration: underline;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-hidden {
  overflow: hidden;
  text-indent: -99999px;
  *text-indent: 0;
  *font-size: 0;
}
.ep-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: none;
  visibility: hidden;
  background: url("//midas.gtimg.cn/enterprise/images/ep_modal_mask.png") 0 0;
}
.ep-mask.show {
  display: block;
  visibility: visible;
}
.ep-modal {
  left: 50%;
  top: 50%;
  z-index: 1100;
  display: none;
  width: 440px;
  height: 280px;
  margin-left: -220px;
  margin-top: -140px;
  background-color: #fff;
  overflow: hidden;
}
.ep-modal,
.ep-modal-mask {
  position: fixed;
  visibility: hidden;
}
.ep-modal-mask {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.ep-modal-mask.show,
.ep-modal.show {
  display: block;
  visibility: visible;
}
.ep-modal-header {
  position: relative;
  height: 40px;
  line-height: 40px;
  padding-left: 14px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background-color: #3584cb;
}
.ep-modal-header .close {
  position: absolute;
  right: 10px;
  top: 13px;
  display: block;
  text-indent: -9999px;
}
.ep-modal-body {
  height: 200px;
}
.ep-modal-body .btns {
  text-align: center;
  margin-top: 50px;
  font-size: 0;
  letter-spacing: normal;
}
.ep-modal-body .btns .ep-btn {
  margin-right: 10px;
}
.ep-modal-body .text {
  padding-top: 50px;
  text-align: center;
  color: #000;
  font-size: 14px;
}
.ep-modal-body .text.text-status {
  text-align: center;
}
.ep-modal-body .text.text-status span {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  line-height: 25px;
  vertical-align: middle;
}
.ep-modal-body .text.text-status .ep-icon {
  margin-right: 8px;
}
.ep-modal-footer {
  height: 40px;
  line-height: 40px;
}
.ep-modal-footer .links {
  text-align: right;
  font-size: 0;
}
.ep-modal-footer .links a {
  color: #4a7cce;
  font-size: 12px;
  margin-right: 17px;
}
.mod-bank {
  width: 559px;
  color: #707070;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  padding: 1px 0 0 1px;
}
.mod-bank .title {
  float: left;
  font-size: 14px;
}
.mod-bank .bank-list {
  float: right;
  width: 480px;
}
.mod-bank:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.mod-bank .bank-logo-wrap {
  background: #fff;
  float: left;
  width: 110px;
  height: 30px;
  line-height: 30px;
  display: block;
  border: 1px solid #dddede;
  margin: 0 7px 7px 0;
  position: relative;
  z-index: 0;
  cursor: pointer;
  text-align: center;
  transition: border-color 200ms;
}
.mod-bank .bank-logo-wrap:hover {
  z-index: 3;
  border-color: #3879d1;
}
.mod-bank .bank-logo-wrap input {
  position: absolute;
  opacity: 0;
  z-index: -1;
  width: 0;
  height: 0;
  overflow: hidden;
}
.mod-bank .bank-logo-wrap a {
  padding-left: 35px;
  text-decoration: underline;
}
.mod-bank .bank-logo-wrap a:hover {
  text-decoration: underline;
}
.mod-bank .bank-logo-wrap.selected {
  z-index: 3;
  width: 108px;
  height: 28px;
  line-height: 28px;
  border: 2px solid #3879d1;
}
.mod-bank .bank-logo-wrap.selected .ep-icon-check {
  display: block;
  animation: iconScale 0.1s linear;
}
.mod-bank .bank-logo-wrap.bank-empty {
  height: 30px;
  margin-bottom: 0;
  padding: 0;
}
.mod-bank .ep-icon-check {
  position: absolute;
  z-index: 5;
  right: 0;
  bottom: 0;
  display: none;
}
.mod-bank .ep-icon-radio {
  vertical-align: text-bottom;
  margin-left: 5px;
  margin-right: 0;
  *margin-right: 4px;
}
.mod-bank .empty .bank-logo-wrap:hover {
  height: 22px;
  line-height: 22px;
  padding: 2px 0;
  background: #fff;
  border: 1px solid #dddede;
}
.layer-neat-l {
  margin-bottom: 20px;
}
.layer-neat-l .label {
  display: inline-block;
  text-align: left;
  width: 75px;
  font-size: 14px;
  margin-right: 2px;
  position: relative;
  line-height: 1.5;
  z-index: 0;
  color: #707070;
}
.layer-neat-l .disabled {
  color: #bcbcbc;
}
.layer-neat-l .hide {
  display: none;
}
.layer-neat-l .ep-icon-radio {
  margin-right: 4px;
  position: relative;
  top: 2px;
}
.layer-neat-l label {
  margin-right: 5px;
  color: #707070;
  font-size: 14px;
  line-height: 14px;
}
.layer-neat-l label input {
  position: absolute;
  z-index: 5;
  right: 0;
  bottom: 0;
  display: none;
}
.bank-disable-tips span {
  font-weight: 600;
}
.ui-input {
  box-sizing: border-box;
  outline: 0;
  height: 30px;
  line-height: 30px;
  border: 1px solid #cdcdcd;
  border-radius: 2px;
  font-size: 14px;
  transition: border-color 0.3s, color 0.3s;
  padding-left: 10px;
  min-width: 100px;
}
.ui-input:focus {
  box-shadow: 0 5px 5px 0 rgba(234, 234, 234, 0.75);
  border-color: #3584cb;
  color: #000;
}
.ui-input.error {
  border-color: #ee5c5c;
}
.input-box {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  position: relative;
}
.cft_b2b-bank {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  margin-right: 2px;
  line-height: 999px;
  vertical-align: -4px;
  background-image: url("//midas.gtimg.cn/enterprise/images/cft_b2b/cft_b2b_bank_sprite.png");
}
.cft_b2b-bank_pab {
  vertical-align: 0;
}
.cft_b2b-bank_icbc {
  vertical-align: -2px;
}
.cft_b2b-bank_cib {
  vertical-align: 0;
}
.cft_b2b-bank_ceb {
  vertical-align: -1px;
}
.cft_b2b-bank_abc {
  background-position: 0 0;
  width: 18px;
  height: 18px;
}
.cft_b2b-bank_boc {
  background-position: -20px 0;
  width: 18px;
  height: 18px;
}
.cft_b2b-bank_ccb {
  background-position: -40px 0;
  width: 17px;
  height: 18px;
}
.cft_b2b-bank_ceb {
  background-position: -20px -40px;
  width: 18px;
  height: 13px;
}
.cft_b2b-bank_cib {
  background-position: -59px -15px;
  width: 18px;
  height: 11px;
}
.cft_b2b-bank_citic {
  background-position: 0 -20px;
  width: 18px;
  height: 18px;
}
.cft_b2b-bank_cmb {
  background-position: -20px -20px;
  width: 18px;
  height: 18px;
}
.cft_b2b-bank_comm {
  background-position: -40px -20px;
  width: 16px;
  height: 18px;
}
.cft_b2b-bank_icbc {
  background-position: -59px 0;
  width: 18px;
  height: 13px;
}
.cft_b2b-bank_pab {
  background-position: -59px -28px;
  width: 18px;
  height: 9px;
}
.cft_b2b-bank_spdb {
  background-position: 0 -40px;
  width: 18px;
  height: 15px;
}
.ep-channel-item-wechat_ecommerce {
  width: 144px !important;
}
.ep-pay-main {
  display: none;
}
.ep-pay-main.show {
  display: block;
}
.ep-status {
  font-size: 18px;
  color: #1e1e1e;
  padding: 20px 0;
  zoom: 1;
  clear: both;
}
.ep-status:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-status span {
  float: left;
  line-height: 25px;
}
.ep-status span.ep-icon {
  margin-right: 8px;
}
.ep-status-fail {
  margin-bottom: 20px;
}
.ep-status-tips {
  position: relative;
  top: -10px;
  margin-left: 30px;
  font-size: 14px;
  color: #888;
}
.ep-dl-list,
.ep-order-con {
  font-size: 14px;
}
.ep-dl-list dl,
.ep-order-con dl {
  zoom: 1;
  clear: both;
  margin-bottom: 15px;
}
.ep-dl-list dl:after,
.ep-order-con dl:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-dl-list dl dd,
.ep-order-con dl dd,
.ep-dl-list dl dt,
.ep-order-con dl dt {
  line-height: 1.5;
}
.ep-dl-list dl dt,
.ep-order-con dl dt {
  float: left;
}
.ep-dl-list dl dd,
.ep-order-con dl dd {
  padding-left: 70px;
  color: #707070;
}
.ep-order-detail .ep-dl-list dl,
.ep-order-detail .ep-order-con dl {
  margin-top: 15px;
  margin-bottom: 0;
}
.ep-order-detail .ep-dl-list dl dt,
.ep-order-detail .ep-order-con dl dt {
  color: #707070;
}
.ep-links {
  zoom: 1;
  clear: both;
}
.ep-links:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-links a {
  float: left;
  color: #4a7cce;
  margin-right: 22px;
}
.ep-pay-step {
  display: none;
}
.ep-order-con p {
  padding-top: 20px;
  color: #707070;
  font-size: 14px;
}
.ep-order-con.show {
  display: block;
}
.ep-pay-method {
  padding-top: 20px;
}
.ep-pay-method dl {
  zoom: 1;
  clear: both;
}
.ep-pay-method dl:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-pay-method dt {
  color: #000;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
}
.ep-pay-methods dt {
  line-height: 44px;
}
.ep-pay-method-list-tit li.selected .ep-pay-method-list-txt {
  display: block;
}
.ep-pay-method-list-txt {
  display: none;
  position: absolute;
  top: 40px;
  left: -3px;
  width: 140px;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  text-align: left;
  cursor: default;
}
.ep-pay-wxpay-tit {
  font-size: 14px;
  color: #424242;
  line-height: 25px;
  margin-bottom: 15px;
  zoom: 1;
  clear: both;
}
.ep-pay-wxpay-tit:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-pay-wxpay-tit span {
  float: left;
}
.ep-pay-wxpay-tit span.ep-icon {
  margin-right: 4px;
}
.ep-wxpay-qrcode-wrap {
  width: 196px;
  height: 196px;
  margin-bottom: 10px;
}
.ep-wxpay-qrcode-notice {
  height: 30px;
  line-height: 30px;
  background-color: #00c800;
  font-size: 12px;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
.ep-wxpay-qrcode-tip {
  margin-left: 40px;
  margin-top: -10px;
}
.ep-qqpay-qrcode-notice {
  height: 30px;
  line-height: 30px;
  background-color: #55a2e3;
  font-size: 12px;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
.ep-other-pay-notice {
  font-size: 14px;
  color: #000;
}
.ep-other-pay-notice a {
  color: #4a7cce;
}
.ep-other-pay-notice span {
  color: #888;
}
.ep-order-detail {
  border-bottom: 1px solid #f3f3f3;
}
.ep-order-tit > span {
  font-size: 15px;
  color: #000;
  font-weight: 700;
}
.ep-order-tit > span > em {
  color: #0ac265;
  font-weight: 400;
  font-size: 24px;
}
.ep-order-view {
  position: relative;
  margin-left: 10px;
  font-size: 14px;
  padding-right: 15px;
  transition: color 0.1s ease-in;
}
.ep-order-view span {
  color: #707070;
}
.ep-order-view .ep-icon-arrow {
  position: absolute;
  right: -2px;
  top: 50%;
  margin-top: -4px;
}
.ep-order-view:hover {
  text-decoration: none;
}
.ep-order-view:hover span {
  color: #4a7cce;
}
.ep-order-view:hover .ep-icon-arrow {
  background-position: -47px -175px;
}
.ep-order-view:active {
  color: #4a7cce;
}
.ep-order-active:hover .ep-icon-arrow {
  background-position: -47px -185px;
}
.ep-order-active .ep-icon-arrow {
  background-position: -35px -185px;
}
.ep-qrcode-notice {
  font-size: 14px;
  color: #888;
  padding-bottom: 20px;
}
.ep-qrcode-notice em,
.ep-qrcode-notice-outmoded {
  color: #f34d4d;
}
.ep-qrcode-notice-outmoded a,
.ep-qrcode-notice a {
  color: #4a7cce;
}
.ep-pay-method-list-tit ul {
  zoom: 1;
  clear: both;
}
.ep-pay-method-list-tit ul:after {
  content: "";
  height: 0;
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
  clear: both;
  display: table;
}
.ep-pay-method-list-tit li {
  position: relative;
  font-size: 0;
  display: block;
  float: left;
  width: 130px;
  height: 44px;
  line-height: 42px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #dedede;
  cursor: pointer;
}
.ep-pay-method-list-tit li + li {
  margin-left: 10px;
  margin-bottom: 8px;
}
.ep-pay-method-list-tit li .ep-pay-method-name {
  transition: color 0.1s ease-in;
}
.ep-pay-method-list-tit li .ep-transfer-confirm-tips,
.ep-pay-method-list-tit li .ep-confirm-tips-content {
  visibility: hidden;
  border-color: #1379d8;
  right: 217px;
  top: -56px;
}
.ep-pay-method-list-tit li .ep-transfer-confirm-tips::after,
.ep-pay-method-list-tit li .ep-confirm-tips-content::after {
  background-image: none;
}
.ep-pay-method-list-tit li .ep-transfer-confirm-tips.ep-iframe,
.ep-pay-method-list-tit li .ep-confirm-tips-content.ep-iframe {
  right: 183px;
}
.ep-pay-method-list-tit li:hover,
.ep-pay-method-list-tit li.hover {
  border-color: #3879d1;
}
.ep-pay-method-list-tit li:hover .ep-pay-method-name,
.ep-pay-method-list-tit li.hover .ep-pay-method-name {
  color: #3879d1;
}
.ep-pay-method-list-tit li:hover .ep-transfer-confirm-tips,
.ep-pay-method-list-tit li.hover .ep-transfer-confirm-tips,
.ep-pay-method-list-tit li:hover .ep-confirm-tips-content,
.ep-pay-method-list-tit li.hover .ep-confirm-tips-content {
  visibility: visible;
}
.ep-pay-method-list-tit li.selected {
  line-height: 40px;
  *height: 42px;
  *width: 128px;
  border: 2px solid #3879d1;
}
.ep-pay-method-list-tit li.selected .ep-icon-selected {
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 0;
}
.ep-pay-method-list-tit li.disabled {
  background-color: #f9f9f9;
  border-color: #dedede;
  color: #bcbcbc;
}
.ep-pay-method-list-tit li.disabled .ep-pay-method-name {
  color: #bcbcbc;
}
.ep-pay-method-list-tit li.disabled:hover,
.ep-pay-method-list-tit li.disabled:active {
  line-height: 42px;
  border: 1px solid #dedede;
}
.ep-pay-method-list-tit li.disabled:hover .ep-pay-method-name,
.ep-pay-method-list-tit li.disabled:active .ep-pay-method-name {
  color: #bcbcbc;
}
.ep-pay-method-list-tit li span {
  display: inline-block;
  color: #707070;
  font-size: 14px;
  line-height: 25px;
  vertical-align: middle;
}
.ep-pay-method-list-tit li .ep-icon {
  margin-right: 4px;
}
.ep-pay-method-list-tit li .ep-if-unionpay-tip {
  position: absolute;
  margin-top: -53px;
  margin-left: 70px;
  float: none;
  display: block;
  width: 120px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #ffc539;
  color: #fff;
  border-radius: 2px;
}
.ep-pay-method-list-con .con {
  display: none;
}
.ep-pay-method-list-con .con.show {
  display: block;
}
.ep-pay-method-list-con .ep-tenpay-con div {
  text-align: right;
}
.ep-pay-method-list-con .ep-tenpay-con .text {
  margin-top: 15px;
  color: #d7d7d7;
}
.ep-qrcode-loading {
  width: 194px;
  height: 194px;
  margin-bottom: 10px;
  border: 1px solid #f1f1f3;
  text-align: center;
}
.ep-qrcode-loading img {
  margin-top: 57px;
}
.ep-qrcode-error-tip {
  text-align: center;
  display: none;
  font-size: 0;
  padding: 10px 0;
  background-color: #fffdee;
  border: 1px solid #ffeec3;
  margin-bottom: 20px;
  width: 408px;
}
.ep-qrcode-error-tip span {
  display: inline-block;
  height: 23px;
  line-height: 23px;
  vertical-align: middle;
}
.ep-qrcode-error-tip span.ep-icon-warning {
  margin-right: 10px;
}
.ep-qrcode-error-tip span.ep_warning_text {
  color: #707070;
  font-size: 14px;
}
.ep-transfer-panel {
  font-size: 14px;
}
.ep-transfer-panel .with-split-line {
  padding-top: 15px;
  border-top: 1px solid #f3f3f3;
}
.ep-transfer-panel .ep-btn {
  margin-top: 35px;
}
.ep-transfer-panel .ep-loader {
  margin-top: 35px;
  color: #707070;
}

.ep-transfer-tips {
  color: #707070;
  line-height: 1.5;
}
.ep-transfer-tips .ep-icon-phone {
  margin-right: 5px;
}
.ep-transfer-form {
  margin-top: 15px;
}
.ep-transfer-form .row {
  margin-bottom: 15px;
}
.ep-transfer-form .title {
  display: inline-block;
  padding-right: 20px;
  color: #707070;
}
.ep-transfer-form .ui-input {
  width: 355px;
}
.ep-transfer-form .ep-icon-right {
  margin-left: 5px;
}
.ep-transfer-form .current-input {
  display: inline-block;
  margin-right: 10px;
  height: 30px;
  padding-left: 10px;
  line-height: 30px;
}
.ep-transfer-form .input-tips {
  margin-top: 10px;
  margin-left: 100px;
  color: #ee5c5c;
}
.ep-transfer-form .action-btn {
  margin-left: 5px;
}
.ep-transfer-payee-info {
  margin-top: 25px;
  padding-bottom: 40px;
  padding-left: 40px;
  background-color: #f6f6f6;
}
.ep-transfer-payee-info .row {
  padding-top: 25px;
}
.ep-transfer-payee-info .title {
  display: inline-block;
  width: 80px;
  color: #707070;
}
.ep-transfer-payee-info .payee-account-tips {
  margin-left: 75px;
  margin-top: 15px;
  color: #f7a04c;
}
.ep-transfer-payee-info .payee-account-tips .ep-icon-notice {
  margin-right: 5px;
}
.ep-question-guide {
  display: none;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  animation: fadeIn linear 200ms forwards;
}
.ep-question-guide-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.7;
}
.ep-question-guide-content {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  width: 1080px;
  height: 630px;
  margin-top: -315px;
  margin-left: -540px;
  background-color: #fff;
  color: #333;
}
.ep-question-guide-header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  background-color: #ebebeb;
}
.ep-question-guide-body {
  padding: 0;
  height: 630px;
  font-size: 14px;
}
.ep-question-guide-body iframe {
  height: 580px;
  width: 100%;
}
.ep-question-guide-footer {
  height: 30px;
}

.ep-question-guide-trigger {
  position: absolute;
  top: 70px;
  right: 300px;
  font-size: 14px;
  font-weight: 600;
  color: #3879d1;
  cursor: pointer;
  z-index: 1000;
}
.ep-question-guide-trigger a:hover {
  text-decoration: none;
}

@keyframes iconScale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes loaderIconRotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.ep-black-mask {
  display: none;
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
label.ep-highlight {
  position: relative;
  z-index: 5000;
}
label.ep-highlight:after {
  position: absolute;
  content: attr(title);
  text-align: left;
  padding-left: 7px;
  line-height: 30px;
  left: -7px;
  top: -8px;
  right: -2px;
  bottom: -8px;
  border-radius: 2px;
  background-color: #fff;
}
.ep-highlight-tooltip {
  display: none;
  line-height: 1.5;
  position: absolute;
  top: 140%;
  left: 0;
  width: 280px;
  margin-top: 14px;
  padding: 15px;
  text-align: left;
  color: #fff;
  border-radius: 3px;
  background-color: #3d3d3d;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.35);
  z-index: 5000;
}
.ep-highlight-tooltip::before {
  position: absolute;
  top: -6px;
  left: 17px;
  display: block;
  width: 0;
  height: 0;
  content: "";
  border-width: 0;
  border-style: solid;
  border-color: transparent;
  border-right-width: 4.5px;
  border-bottom-width: 6px;
  border-bottom-color: #3d3d3d;
  border-left-width: 4.5px;
}
.ep-highlight-btn {
  float: right;
  padding: 0 10px;
  line-height: 30px;
  border: 1px solid #676767;
  border-radius: 4px;
  cursor: pointer;
}
.ep-highlight-btn:hover {
  color: #3d3d3d;
  background: #fff;
}
.ep-transfer-confirm-tips {
  position: absolute;
  right: 20px;
  top: 8px;
}
.ep-transfer-confirm-tips.ep-iframe {
  right: 150px;
}
.ep-transfer-confirm-tips:hover .ep-confirm-tips-content.ep-hover {
  visibility: visible;
}
.ep-confirm-tips-content {
  position: absolute;
  left: 170%;
  top: -50px;
  width: 310px;
  padding: 15px 20px;
  box-sizing: border-box;
  border: 1px solid #ff9243;
  border-radius: 4px;
  box-shadow: 0 5px 5px 0 rgba(201, 201, 201, 0.35);
  font-size: 12px;
  line-height: 1.58333333;
  background-color: #fff;
  color: #8b8b8b;
  visibility: hidden;
}
.ep-confirm-tips-content.ep-resident {
  visibility: visible;
}
.ep-confirm-tips-content:after {
  position: absolute;
  content: "";
  left: -9px;
  top: 50px;
  width: 9px;
  height: 14px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkJCNDFDRTJBRjU5MTFFNjkzNkFCMDJFNDgzMTI3NkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MkJCNDFDRTFBRjU5MTFFNjkzNkFCMDJFNDgzMTI3NkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1MDYzOTdEOEFFRkMxMUU2OTM2QUIwMkU0ODMxMjc2QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1MDYzOTdEOUFFRkMxMUU2OTM2QUIwMkU0ODMxMjc2QSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PksuV2IAAAETSURBVHjaYjx58iQDGmAGYg4g5uL7eEdC4/bisywMOIDqzUXKAh9uzGcwDGHApojR8EyTD+vvr9MY7LN5GQzQFGlcncnC+/l+E+P/f8UMgT2MDHImYHG4IuNTNWLMf38vZtAPcGSwTGFgYOeGawYpYjQ9UWnC+P/vCgbzeFkGi0QM+5ln69xJYWT4t5zBtVyIwTAUqyeY/jExfwMa9pPh+wdcHmVgbtx27/L7W6e2s9/ZY8L4/YMUg5gaAwMrJ6qq////w/H3mSFT/k9w+P7/+q5fQD4coygC4Wer6nP+TnJ5/P/ITLgiRpAENvBjZugBDkUjKwY9fwYmXI7lSF/t8ObNmxkMlzYy4DQJDiY6/AIIMACnnYQM2rIGHwAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
}
.ep-confirm-tips-content strong {
  font-size: 14px;
  color: #fa8333;
}
.ep-confirm-tips-content .ep-icon-close-s {
  position: absolute;
  top: 7px;
  right: 5px;
  cursor: pointer;
}
.ep-confirm-tips-content .ep-icon-close-s:hover {
  transition: transform 250ms ease-in-out;
  transform: rotate(180deg);
}
.ep-confirm-tips-content .ep-icon-close-s::after {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
}
.ep-transfer-form .row,
.ep-transfer-payee-info .row.relative {
  position: relative;
}
.ep-sprite-icon {
  display: inline-block;
  vertical-align: middle;
}

.hd {
  height: 70px;
  color: #fff;
  background-color: #000;
}
.hd-main {
  width: 1080px;
  height: 100%;
  margin: 0 auto;
  *zoom: 1;
}
.hd-main:after,
.hd-main:before {
  content: "";
  display: table;
}
.hd-main:after {
  clear: both;
}
.ep-hd-info {
  float: left;
  height: 100%;
  font-size: 0;
}
.ep-logo,
.ep-order-status {
  float: left;
}
.ep-logo {
  padding-top: 25px;
}
.ep-logo a {
  display: block;
}
.ep-logo img {
  width: 114px;
}
.ep-order-status {
  margin: 23px 0 0 20px;
  padding-left: 20px;
  border-left: 1px solid #f0f0f0;
  line-height: 26px;
  font-size: 16px;
}
.ep-order-status h1 {
  font-size: 16px;
  font-weight: 700;
}
.user-info {
  float: right;
  margin-top: 20px;
}
.user-info p {
  font-size: 14px;
}
.ft {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 140px;
  clear: both;
  padding-top: 16px;
}
.ft-main {
  width: 1080px;
  margin: 0 auto;
}
.copyright {
  padding-bottom: 80px;
  color: #bbb;
}
.copyright p {
  text-align: center;
  padding: 6px 0;
}
html,
body,
.container {
  height: 100%;
}
.container {
  min-height: 100%;
  height: auto !important;
  position: relative;
  background: #efefef;
}
.bd {
  padding: 40px 0 200px;
}
.bd-main {
  width: 1080px;
  margin: 0 auto;
  background: #fff;
}
.bd-main-container {
  padding: 50px 270px 50px 250px;
}
.ep-wrapper {
  position: relative;
  margin-left: 0;
}
.ep-wp-hd {
  padding: 22px 135px;
  background: #f5fef3;
}
.fail .ep-wp-hd {
  background-color: #f9f9f9;
}
.ep-wp-bd {
  padding: 0 135px 56px;
}
.ep-status-success {
  border: none;
}
.ep-status-success .mod-it-text {
  font-weight: 700;
}
.ep-links {
  font-size: 14px;
  padding-bottom: 20px;
  margin-top: 25px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.ep-dl-list {
  position: relative;
  padding-top: 40px;
}
.ep-dl-list .dl-list-more {
  position: absolute;
  left: 150px;
  bottom: 0;
}
.ep-question {
  margin-bottom: 30px;
  font-size: 14px;
  color: #888;
}
.ep-question p {
  padding: 10px 0;
}
.ep-order-detail {
  padding: 10px 0 20px;
}
.ep-order-detail .ep-order-con {
  padding-left: 72px;
}
.ep-order-tit {
  position: relative;
}
.ep-order-tit .rmb {
  margin: 0 8px 0 4px;
}
.ep-order-tit .rmb i {
  font-size: 18px;
}
.ep-order-tit span {
  font-size: 14px;
}
.ep-order-tit dl {
  padding-bottom: 12px;
}
.ep-order-tit dt,
.ep-order-tit dd {
  font-size: 14px;
}
.ep-order-tit dt {
  float: left;
  color: #000;
  font-weight: 700;
}
.ep-order-tit dd {
  color: #707070;
}
.fail .ep-order-con p:first-child {
  padding-top: 0;
}
.ep-pay-method dt {
  float: none;
}
.ep-pay-method dd {
  padding-left: 0;
  float: none;
}
.ep-pay-success-tips {
  font-size: 14px;
  color: #888;
}
.ep-pay-success-tips a {
  padding-right: 4px;
  color: #3879d1;
}
.ep-pay-qqpay-tips {
  display: none;
  position: absolute;
  margin-top: 5px;
  width: 233px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  color: #888;
  background-image: linear-gradient(to top, #f0f0f4, #fff);
  filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#ffffff, endcolorstr=#f0f0f4, gradientType=0);
  box-shadow: 2px 2px 5px rgba(185, 185, 185, 0.5);
  border: 1px solid #d0d0d0;
  border-radius: 1px;
}
.ep-pay-operate {
  padding-bottom: 120px;
}
.ep-qrcode-notice em {
  font-weight: 700;
}
.hide {
  display: none;
}
.ep-question-guide.show {
  display: block;
  z-index: 1000;
}
.ep-pay-method-list-tit {
  margin-bottom: 25px;
}
.ep-pay-method-list-tit .ep-pay-method-list-txt {
  display: none;
  position: absolute;
  top: 40px;
  left: -3px;
  width: 140px;
  color: #afafaf;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  text-align: left;
}
.ep-pay-method-list-tit li {
  transition: border-color 0.1s ease-in, color 0.1s ease-in;
}
.ep-pay-method-list-tit li.selected .ep-pay-method-list-txt {
  display: block;
}
.ep-pay-method-list-tit li.selected .ep-icon-selected {
  transform-origin: 100% 100%;
  animation: iconScale 0.1s linear;
}
.ep-pay-method-list-txt {
  padding: 10px 0;
  color: #afafaf;
}
.ep-pay-method-list-con .ep-pay-operate {
  padding-top: 25px;
}
.ep-pay-method-list-con .ep-unionpay-con .ep-unionpay-img {
  margin-top: 10px;
}
.ep-qrcode-error-tip {
  margin-top: 20px;
}
.ep-pay-method-list-txt.reminder-tip {
  color: #f7a04c;
  font-size: 12px;
}
</style>
    